import { SAMPLE_NOTES } from "../sampleContent";

/** Guided first-run: create app → add notes → processing → Inbox review (real screens). */
export const ADD_KNOWLEDGE_FIRST_APP = {
  id: "add-knowledge-first-app",
  title: "First application on the map",
  sampleName: "Customer Payments Hub",
  sampleNotes: SAMPLE_NOTES,
  chapters: [
    {
      id: "intent",
      title: "Put an application on the map",
      tip: "Guided demo — tap Try an example — Customer Payments Hub below (creates the app, then enriches it).",
      tipMobile: "Guided demo — tap Try an example — Customer Payments Hub below.",
      // Entry CTA lives on the Ask welcome chip (blink), not this strip.
      body:
        "Enterprise architecture used to mean months of workshops and diagrams that go stale the week after. DecisionPen lets you model in natural language — describe a system once, and we organise it into a living map that enterprise and solution architects can share, question, and decide from at the pace of AI.",
    },
    {
      id: "create-app",
      title: "Name the application",
      tip: "Click Create entity to add Customer Payments Hub, then Continue.",
      tipMobile: "Tap Create entity to add Customer Payments Hub, then Continue.",
      body:
        "Every landscape needs a system of interest. We'll create Customer Payments Hub (CPH) — a familiar payments orchestration application — so you can see how DecisionPen turns a name into an anchor on your map.",
      advanceOn: "anchor-continued",
    },
    {
      id: "choose-how",
      title: "Choose how to add knowledge",
      tip: "Click the Paste or type card for the quickest first run.",
      tipMobile: "Tap Paste or type for the quickest first run.",
      body:
        "Now we enrich CPH with what you already know. You can paste a description, upload design documents, or point at a file in your repository (for example an S3 bucket). Same intelligence path — pick the source that matches how your team works.",
      advanceOn: "method-picked",
    },
    {
      id: "supply",
      title: "Supply the material",
      tip: "When you're ready, click Add knowledge / Extract.",
      tipMobile: "When you're ready, tap Add knowledge / Extract.",
      body:
        "The box is pre-filled with notes for Customer Payments Hub — what it does, who owns it, and which applications and platforms it talks to. That is natural-language enterprise modelling: enough signal for the agent to draft neighbours and flows without inventing systems you never named.",
      primaryLabel: "Load sample notes",
      primaryAction: "load-sample",
      advanceOn: "job-queued",
    },
    {
      id: "processing",
      title: "Building your map",
      tip: "Building your map — open Inbox when you’re ready. Other menus stay locked.",
      tipMobile: "Building your map — open Inbox from the tabs when you’re ready.",
      body:
        "DecisionPen is reading your material the way an architect would: naming the system of interest, matching known technology, drafting neighbours and flows, and parking gaps instead of inventing them. This is the same engine you'll use every day — not a demo shortcut.",
      primaryLabel: "Open Inbox",
      primaryAction: "open-inbox",
      advanceOn: "job-ready",
    },
    {
      id: "review",
      title: "You stay architect of record",
      tip: "Open Review on your upload, then approve, link, or skip each suggestion.",
      tipMobile: "Open Review on your upload, then approve, link, or skip.",
      body:
        "AI proposes; you decide. Review the entities and relations it identified — Add what belongs on the map, Link when it is the same thing under another name, Skip gaps you are not ready to fill. Nothing joins the live landscape until you say so.",
      primaryLabel: "Open review",
      primaryAction: "open-review",
      advanceOn: "review-complete",
    },
    {
      id: "win",
      title: "Ask the agent",
      tip: "Your first slice is on the map — ask the agent about Customer Payments Hub.",
      tipMobile: "Open Ask and pick a question about Customer Payments Hub.",
      body:
        "You just walked the real path: Add knowledge → modelling → Inbox → Ask. That shared enterprise context is what lets teams interrogate the landscape, draft blueprints, and decide with confidence — architecture that moves at the speed of AI coding.",
      primaryLabel: "Open Ask",
      primaryAction: "open-ask",
      secondaryLabel: "Finish",
      secondaryAction: "complete",
    },
  ],
};

export function getScript(scriptId) {
  if (scriptId === ADD_KNOWLEDGE_FIRST_APP.id) return ADD_KNOWLEDGE_FIRST_APP;
  return null;
}
